// extracted by mini-css-extract-plugin
module.exports = {"container":"_3wS1ZPjZSdMpsECnvaDauL","title":"_3ZptPBXhF4tot-eurt6G5z","actions":"_3-lqDN0yGmMVe9thnLp7_X","action":"Tg30NudBvz6lr206qrsrI","actionTitle":"_1qTS-9IoAxX8Dt3yEdLj7Y"};